import { gql } from "apollo-boost";

export const GQL_ALTER_LIKE = gql`
  mutation($ald: AlterLikeDto!) {
    alterLike(alterLikeDto: $ald)
  }
`;

export const GQL_GET_MY_LIKE = gql`
  query($skip: Int, $take: Int) {
    getMyLike(skip: $skip, take: $take) {
      count
      results {
        id
        updated_at
        url
      }
    }
  }
`;
